import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { ProgressService } from '../progress.service';
import { Progress } from '../progress.model';
import { File } from '../file-model';
import { sortBy, get, lowerCase, includes, chain } from 'lodash';
import { BsModalService } from 'ngx-bootstrap';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { unescape } from 'lodash';
import { Encoder } from '../../../utils/encoder';
import { resolve } from 'url';

@Component({
  selector: 'app-progress',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class ProgressFormComponent implements OnInit {

  deleteModalRef: BsModalRef;
  detailModelRef: BsModalRef;
  files: Array<File>;
  errorsList: Array<any>;
  loading: boolean = false;
  fileKey: string;
  showErrorAlert = false;
  showSuccessAlert = false;
  errorMessage: string = null;
  successMessage: string = null;
  progress: Progress = new Progress();
  downloadLink: any;
  warningList: Array<any>;

  fileDetail: any = {
    fileName: '',
    date: '',
    total: '',
    success: '',
    fail: '',
    errorSummary: [],
    warningSummary: []
  };

  ErrorFilePath: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private progressService: ProgressService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(value => {
      this.progress.progressId = value.progressId;
    });
    this.progressService.getProgressById(this.progress.progressId).subscribe(res => {
      this.progress = res.data;
      this.files = this.progress.files;
      this.progressService.getErrorPackage().subscribe(val => {
        let errorlist = JSON.parse(JSON.stringify(this.progress.errorSummary));
        let warninglist = JSON.parse(JSON.stringify(this.progress['warningSummary']));
        errorlist.forEach(ele => {
          ele.name = val[ele.name];
        });
        warninglist.forEach(ele => {
          ele.name = val[ele.name];
        })
        this.warningList = warninglist;
        this.errorsList = errorlist;
      })
    })
  }

  deleteShowModal(template: TemplateRef<any>, fileKey): any {
    this.fileKey = Encoder.encode(fileKey);
    this.deleteModalRef = this.modalService.show(template, {
      ignoreBackdropClick: true
    });
  }

  detailShowModal(template: TemplateRef<any>, data) {

    this.ErrorFilePath = 'loading path.....'
    let fileName = data.fileName.substring(0, data.fileName.lastIndexOf("."));
    let content = `${this.progress.region}/${this.progress.buName}/${this.progress.country}/${this.progress.providerName}`
    let params;
    if (this.progress.providerId == '0') {
      params = `batch/${fileName}-error-reporting.csv`;
    } else {
      params = `batch/${content}/${fileName}-error-reporting.csv`;
    }
    this.progressService.getErrorFileLink({ key: params }).subscribe(res => {
      if (res) {
        let overTime = data.date + (1000 * 60 * 10);
        let nowTime = new Date().getTime();
        if (overTime > nowTime) {
          this.ErrorFilePath = 'Error report file is generating...';
          this.downloadLink = '';
          return;
        }
        this.downloadLink = res.data.resData;
        let start = this.downloadLink.lastIndexOf('/batch');
        let end = this.downloadLink.lastIndexOf('.csv');
        this.ErrorFilePath = this.downloadLink.substring(start, end + 4);

      } else {
        this.downloadLink = '';
        this.ErrorFilePath = 'Error report file is generating...';
      }
    })

    let result = JSON.parse(JSON.stringify(data));
    this.progressService.getErrorPackage().subscribe(val => {
      result.errorSummary.forEach(ele => {
        ele.name = val[ele.name];
      });
      result.warningSummary.forEach(ele => {
        ele.name = val[ele.name];
      });
      this.fileDetail = result;

      this.detailModelRef = this.modalService.show(template, {
        ignoreBackdropClick: true,
        class: 'gray modal-lg',
      });
      const dom: any = document.getElementsByClassName('gray')[0];
      dom.style.minWidth = '1000px';
    })
  }

  deleteConfirm() {
    this.activatedRoute.params.subscribe(value => {
      this.loading = true;
      this.progressService.deleteFileByFileKey(value.progressId, this.fileKey).subscribe(res => {
        this.showSuccessAlert = true;
        this.successMessage = 'File deleted successfully';
        this.deleteModalRef.hide();
        this.progressService.getProgressById(value.progressId).subscribe(res => {
          this.loading = false;
          this.progress = res.data;
          this.files = this.progress.files;
        })
      }, error => {
        this.loading = false;
        this.deleteModalRef.hide();
        this.showErrorAlert = true;
        this.errorMessage = error;
      });
    })
  }

  successMessageClose(): void {
    this.showSuccessAlert = false;
    this.successMessage = '';
  }
  errorMessageClose(): void {
    this.showErrorAlert = false;
    this.errorMessage = '';
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true })
      .then(() =>
        this.router.navigate([uri]));
  }

  showModal(data) {
    console.log(data)
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/progress/detail/detail.component.ts